fragment workBlockInfoForSubscription on WorkBlock {
  effectiveLabor
  endsAt
  id
  productionRateOverride
  performanceOverride
  efficiencyOverride
  laborOverride
  lockedOnSchedule
  productionRateDependsOnNumberOfPeople
  quantity
  standardPeople
  standardProductionRate
  performance
  startsAt
  teardownTimeLabel
  teardownTimeDuration
  unitOfMeasure
  lineEfficiency
  line {
    id
  }
  overlappingPlannedBreaks {
    plannedBreakName
    duration
  }
  workOrder {
    id
  }
  workTimeEndsAt
  workTimeStartsAt
  jobId
}
